import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

const LANGS = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'ar', label: 'العربية' },
  { code: 'es', label: 'Español' },
  { code: 'pt', label: 'Português' },
  { code: 'dt', label: 'Deutsch' },
];

export const runMainTour = (i18n) => {
  const tr   = (key) => i18n.t(key);
  const side = i18n.language === 'ar' ? 'left' : 'right';

  const langSelectHTML = `
    <div style="margin-top:16px;display:flex;align-items:center;gap:10px;">
      <span style="font-size:13px;color:var(--app-light-ink, #8a94a6);">🌐</span>
      <select id="tour-lang-select"
        style="flex:1;background:#1a2040;color:var(--app-light-ink, #e8ecf0);border:1px solid rgba(24,230,142,0.35);
               border-radius:8px;padding:6px 10px;font-size:12px;font-weight:600;
               cursor:pointer;outline:none;appearance:none;
               background-image:url('data:image/svg+xml;utf8,<svg fill=\\'%2318e68e\\' viewBox=\\'0 0 10 6\\' xmlns=\\'http://www.w3.org/2000/svg\\'><path d=\\'M0 0l5 6 5-6z\\'/></svg>');
               background-repeat:no-repeat;background-position:right 10px center;background-size:8px;
               padding-right:28px;">
        ${LANGS.map(l =>
          `<option value="${l.code}"${i18n.language === l.code ? ' selected' : ''}>${l.label}</option>`
        ).join('')}
      </select>
    </div>`;

  let driverObj;
  driverObj = driver({
    popoverClass: 'driverjs-theme',
    showProgress: true,
    showButtons: ['next', 'previous', 'close'],
    progressText: '{{current}} / {{total}}',
    nextBtnText: side === 'left' ? '←' : '→',
    prevBtnText: side === 'left' ? '→' : '←',
    doneBtnText: tr('tour.done'),
    onPopoverRender: (_popover, { state }) => {
      if (state.activeIndex !== 0) return;
      setTimeout(() => {
        const sel = document.getElementById('tour-lang-select');
        if (!sel) return;
        sel.addEventListener('change', async (e) => {
          await i18n.changeLanguage(e.target.value);
          driverObj.destroy();
          runMainTour(i18n);
        });
      }, 50);
    },
    steps: [
      {
        popover: {
          title: tr('tour.welcome.title'),
          description: tr('tour.welcome.description') + langSelectHTML,
          align: 'center'
        }
      },
      { element: '#general',         popover: { title: tr('tour.overview.title'),      description: tr('tour.overview.description'),      side, align: 'start' } },
      { element: '#profile',         popover: { title: tr('tour.profile.title'),        description: tr('tour.profile.description'),        side, align: 'start' } },
      { element: '#company',         popover: { title: tr('tour.company.title'),        description: tr('tour.company.description'),        side, align: 'start' } },
      { element: '#lost-items',      popover: { title: tr('tour.lost_items.title'),     description: tr('tour.lost_items.description'),     side, align: 'start' } },
      { element: '#restaurant-menu', popover: { title: tr('tour.menu.title'),           description: tr('tour.menu.description'),           side, align: 'start' } },
      { element: '#reservations',    popover: { title: tr('tour.reservations.title'),   description: tr('tour.reservations.description'),   side, align: 'start' } },
      { element: '#claims',          popover: { title: tr('tour.claims.title'),         description: tr('tour.claims.description'),         side, align: 'start' } },
      { element: '#claimshistory',   popover: { title: tr('tour.claims_history.title'), description: tr('tour.claims_history.description'), side, align: 'start' } },
      { element: '#claimsMessanger', popover: { title: tr('tour.messenger.title'),      description: tr('tour.messenger.description'),      side, align: 'start' } },
      { element: '#managers',        popover: { title: tr('tour.managers.title'),       description: tr('tour.managers.description'),       side, align: 'start' } },
      { element: '#responsible',     popover: { title: tr('tour.responsibles.title'),   description: tr('tour.responsibles.description'),   side, align: 'start' } },
      { element: '#claimmanager',    popover: { title: tr('tour.claim_managers.title'), description: tr('tour.claim_managers.description'), side, align: 'start' } },
    ]
  });
  driverObj.drive();
};
